<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-12 col-md-6">
      <form #form="ngForm" (ngSubmit)="form.form.valid && submit(form)" novalidate>
        <h3>{{"shared.password_recovery.recovery_password" | translate}}</h3>
        <p class="small"> {{"shared.password_recovery.recovery_password_info" | translate}}</p>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>{{"shared.password_recovery.email" | translate}}</label>
              <input type="email" class="form-control" name="username" [(ngModel)]="email" #emailVal="ngModel" [ngClass]="inputFieldCss(emailVal, form)" app-email [required]>
              <app-field-error-display [control]="emailVal" [form]="form"></app-field-error-display>
            </div>
          </div>
        </div>
        <div class="col-12 text-right">
          <button class="btn btn-primary float-left" type="button" (click)="onBack()">{{"shared.password_recovery.back" | translate}}</button>
          <button type="submit" class="btn btn-primary" [disabled]="!email">{{"shared.password_recovery.send" | translate}}</button>
        </div>
      </form>
    </div>
  </div>
</div>